var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Copies link to clipboard
 * @param url - link to copy
 * @returns Promise<boolean> - true if copying is successful, false if error
 */
export const copyLink = (url) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // Check if Clipboard API is supported
        if (navigator.clipboard && window.isSecureContext) {
            yield navigator.clipboard.writeText(url);
            return true;
        }
        else {
            // Fallback for old browsers or insecure context
            return fallbackCopyTextToClipboard(url);
        }
    }
    catch (error) {
        console.error('Error copying link:', error);
        return false;
    }
});
/**
 * Fallback method for copying text to clipboard
 * Used when Clipboard API is not available
 */
const fallbackCopyTextToClipboard = (text) => {
    try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        // Make textarea invisible
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        return successful;
    }
    catch (error) {
        console.error('Error copying link:', error);
        return false;
    }
};
/**
 * Shows notification about successful copying
 */
export const showCopyNotification = (text) => {
    const notification = document.createElement('div');
    notification.textContent = text;
    notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #10b981;
    color: white;
    padding: 12px 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 10000;
    font-size: 14px;
    font-weight: 500;
    animation: slideIn 0.3s ease-out;
  `;
    // Add CSS animation
    const style = document.createElement('style');
    style.textContent = `
    @keyframes slideIn {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
  `;
    document.head.appendChild(style);
    document.body.appendChild(notification);
    // Remove notification after 3 seconds
    setTimeout(() => {
        notification.style.animation = 'slideIn 0.3s ease-out reverse';
        setTimeout(() => {
            if (notification.parentNode) {
                document.body.removeChild(notification);
            }
            if (style.parentNode) {
                document.head.removeChild(style);
            }
        }, 300);
    }, 3000);
};
